module.exports = __webpack_public_path__ + "img/menjinkongzhiqi.fa1987a4.jpg";